import { render, staticRenderFns } from "./EditCategoryAdmin.vue?vue&type=template&id=52f7f49a&"
import script from "./EditCategoryAdmin.vue?vue&type=script&lang=js&"
export * from "./EditCategoryAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports